export default __webpack_public_path__ + "static/media/02e_fold-11.792800a4.mp4";